module.exports = __webpack_public_path__ + "static/service1-2209a7aa65123475a6e1ad5e00d17de0.png";